// Libs
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
// Components
import { Span } from 'components';
// Context
import { ElementViewBuilderContext } from 'core/context';
// Config
import { ElementViewBuilderConfig } from 'core/ElementViewBuilder';
// Selectors
import { selectSelectedDataFilterId } from 'core/selectors';
// Utils
import {
	normalizeDatasourceAccessId,
	ORDER_OVERVIEW_MODES,
} from 'core/datasourceAccess';

const OrderId = ({
	elementId,
	odtId,
	disableOverview,
	orderOverviewMode = ORDER_OVERVIEW_MODES.DATASOURCE,
}) => {
	const { setElementView } = useContext(ElementViewBuilderContext);
	const datasourceAccessId = normalizeDatasourceAccessId(
		useSelector(selectSelectedDataFilterId),
	);
	const useResourceOverview =
		orderOverviewMode === ORDER_OVERVIEW_MODES.RESOURCE;
	const elementViewKeys =
		ElementViewBuilderConfig.getAuthorizedElementViewKeys();

	const handleOpenOverview = () => {
		if (disableOverview) return;

		setElementView({
			mode: 'stack',
			elementViewKey: elementViewKeys.ORDER_ELEMENT,
			elementId,
			...(useResourceOverview
				? { orderOverviewMode: ORDER_OVERVIEW_MODES.RESOURCE }
				: datasourceAccessId
					? { datasourceAccessId }
					: {}),
		});
	};

	return <Span onClick={handleOpenOverview}>{odtId}</Span>;
};
export default OrderId;
